import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import {
  SnbMenuHeader,
  SnbLoginTimer,
  SnbMenuList,
} from '@components/common/snb/elements';

import { checkRdopCont } from '@store/actions/commonAction';
import { useDispatch } from 'react-redux';

const SnbMenuBar = () => {
  const { menus } = $hooks.useRoute();
  const { confirm } = $hooks.useModal();
  const { logout, userInfo } = $hooks.useUser();
  const { getDeviceInfoNative } = $hooks.useAppCheck();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(checkRdopCont({ userInfo }));
  }, []);
  const handleLogout = () => {
    confirm({
      message: '로그아웃을 하시겠습니까?',
      onClose: isOk => {
        if (isOk) logout();
      },
      okLabel: '예',
      cancelLabel: '아니오',
    });
  };

  return (
    <nav className={classNames('nav', isNavOpen ? 'close' : '')}>
      <SnbLoginTimer />
      <SnbMenuHeader />

      {/* 메뉴 목록 */}
      <SnbMenuList depth={1} menus={menus} />

      {/* Close Toggle 버튼 */}
      <button
        type="button"
        className="btn-toggle"
        onClick={() => setIsNavOpen(!isNavOpen)}
      />

      {$utils.isInApp && (
        <span className="mgr-5 text-center">
          현재 앱 버전 : {getDeviceInfoNative().appVersion}
        </span>
      )}

      {/* 로그아웃 버튼 */}
      <button type="button" className="btn-lnb logout" onClick={handleLogout}>
        <span className="ico ico-gnb logout"></span>
        <strong className="tit">로그아웃</strong>
      </button>
    </nav>
  );
};

export default SnbMenuBar;
